import { useState } from "react";
import { useEffect } from "react";
import InputData from "./InputData";
import ButtonIconH from "./ButtonIconH";
import InputTextArea from "./InputTextArea";
import CheckBox from "./CheckBox";
import Dropdown from "./Dropdown";
import {
  focusElement,
  supplierStructure,
  userData,
  areObjectsEqual,
  provinceOptions,
} from "../js/utils";
import { post } from "../js/post";
import { openWhatsapp } from "../support-extra/js/comms";
import moment from "moment";
import "../css/SuppliersPanel.css";

export default function SupplierCard(props) {
  const [currentSupplier, setCurrentSupplier] = useState(supplierStructure);
  const [currentSupplierCheck, setCurrentSupplierCheck] =
    useState(supplierStructure);

  // console.log("currentSupplier: ", currentSupplier);

  const saveSupplier = async () => {
    if (
      !currentSupplier.audifonos &&
      !currentSupplier.gafas &&
      !currentSupplier.lentillas &&
      !currentSupplier.liquidos &&
      !currentSupplier.monturas &&
      !currentSupplier.varios &&
      !currentSupplier.gafas
    ) {
      props.createPopupQuestion(
        `Debe seleccionar al menos una familia.`,
        () => {
          props.removePopupQuestion();
        },
        null,
        "Aceptar",
      );
      return;
    }
    if (currentSupplier.nif !== "" && currentSupplier.empresa !== "") {
      const response = await post("GuardarProveedor.php", {
        ...currentSupplier,
        token: userData.token,
        idProveedor: currentSupplier.id,
      });
      // console.log(
      // "GUARDANDO PROVEEDOR: ",
      // {
      // ...currentSupplier,
      // token: userData.token,
      // idProveedor: currentSupplier.id,
      // },
      // response,
      // );
      if (response.error === "") {
        props.createPopupQuestion(
          `La ficha de proveedor se ha guardado de forma correcta.`,
          props.removePopupQuestion,
          null,
          "Aceptar",
        );
        setCurrentSupplier({ ...currentSupplier, id: response.idProveedor });
        setCurrentSupplierCheck({
          ...currentSupplier,
          id: response.idProveedor,
        });
      } else {
        props.createPopupQuestion(
          response.error,
          props.removePopupQuestion,
          null,
          "Aceptar",
        );
      }
    } else {
      props.createPopupQuestion(
        `Por favor, rellene los campos obligatorios (*).`,
        props.removePopupQuestion,
        null,
        "Aceptar",
      );
    }
  };

  const deleteSupplier = async () => {
    await post("EliminarProveedor.php", {
      token: userData.token,
      idProveedor: currentSupplier.id,
      idUsuario: userData.id,
    });
  };

  const openEmail = (email) => {
    const isSupported = window.navigator && window.navigator.msLaunchUri;

    if (isSupported) {
      // Edge
      window.navigator.msLaunchUri(`mailto:${email}`, null, () => {});
    } else {
      // Otros navegadores
      window.location.href = `mailto:${email}`;
    }
  };

  useEffect(() => {
    setCurrentSupplier(props.supplier);
    setCurrentSupplierCheck(props.supplier);
  }, [props.supplier]);

  useEffect(() => {
    focusElement(10);
  }, [props]);

  return (
    <div className="popup-container">
      <div className="ap-container popup-screen">
        <div className="popup-screen-header">
          <span className="popup-screen-header-title">Ficha de proveedor</span>
          <button
            className="popup-action-icon close-icon"
            onClick={() => {
              if (!areObjectsEqual(currentSupplier, currentSupplierCheck)) {
                props.createPopupQuestion(
                  `Existen cambios sin guardar en la ficha actual del proveedor. ¿Desea guardar los cambios antes de cerrar?`,
                  async () => {
                    await saveSupplier();
                  },
                  async () => {
                    props.onClose();
                    props.removePopupQuestion();
                  },
                  "Sí",
                  "No",
                );
              } else {
                props.onClose();
              }
            }}
          >
            <img src="/images/close-white.svg" loading="lazy" alt="Icon"></img>
          </button>
        </div>
        <div
          className="tab-content ap-content"
          style={{ overflow: "unset", backgroundColor: "#f9f9f9" }}
        >
          <div className="supplier-container">
            {currentSupplier.id !== -1 && (
              <span className="section-content-title">
                {currentSupplier.actualizacion
                  ? `Actualizado el ${moment(
                      currentSupplier.actualizacion,
                    ).format("DD/MM/YYYY")}`
                  : "Actualizado: -"}
              </span>
            )}
            <div className="section-content-sep"></div>
            <div className="supplier-info-container">
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "40px",
                  }}
                >
                  <div className="supplier-info-container-col">
                    <div className="data-field">
                      <span className="label">NIF (*)</span>
                      <InputData
                        tabIndex={10}
                        maxLength={20}
                        type="type-alphanum-ext"
                        size={3}
                        input={currentSupplier.nif}
                        onChange={(e) => {
                          setCurrentSupplier({
                            ...currentSupplier,
                            nif: e,
                          });
                        }}
                      ></InputData>
                    </div>
                    <div className="data-field">
                      <span className="label">Empresa (*)</span>
                      <InputData
                        tabIndex={11}
                        maxLength={60}
                        type="type-alphanum-ext"
                        size={3}
                        input={currentSupplier.empresa}
                        onChange={(e) => {
                          setCurrentSupplier({
                            ...currentSupplier,
                            empresa: e,
                          });
                        }}
                      ></InputData>
                    </div>
                    <div className="data-field">
                      <span className="label">Responsable</span>
                      <InputData
                        tabIndex={12}
                        maxLength={60}
                        type="type-alphanum-ext"
                        size={3}
                        input={currentSupplier.responsable}
                        onChange={(e) => {
                          setCurrentSupplier({
                            ...currentSupplier,
                            responsable: e,
                          });
                        }}
                      ></InputData>
                    </div>
                    <div className="data-field">
                      <span className="label">Contacto</span>
                      <InputData
                        tabIndex={13}
                        maxLength={60}
                        type="type-alphanum-ext"
                        size={3}
                        input={currentSupplier.contacto}
                        onChange={(e) => {
                          setCurrentSupplier({
                            ...currentSupplier,
                            contacto: e,
                          });
                        }}
                      ></InputData>
                    </div>
                    <div className="data-field">
                      <span className="label">Dirección</span>
                      <InputData
                        tabIndex={14}
                        maxLength={60}
                        type="type-alphanum-ext"
                        size={3}
                        input={currentSupplier.direccion}
                        onChange={(e) => {
                          setCurrentSupplier({
                            ...currentSupplier,
                            direccion: e,
                          });
                        }}
                      ></InputData>
                    </div>
                    <div className="data-field">
                      <span className="label">Localidad</span>
                      <InputData
                        tabIndex={15}
                        maxLength={60}
                        type="type-alphanum-ext"
                        size={3}
                        input={currentSupplier.localidad}
                        onChange={(e) => {
                          setCurrentSupplier({
                            ...currentSupplier,
                            localidad: e,
                          });
                        }}
                      ></InputData>
                    </div>
                    <div className="data-field">
                      <span className="label">Provincia</span>
                      <Dropdown
                        tabIndex={16}
                        id="provincia"
                        optionList={provinceOptions}
                        size={3}
                        mandatory={false}
                        op={currentSupplier.provincia}
                        onChange={(e) => {
                          setCurrentSupplier({
                            ...currentSupplier,
                            provincia: e.text,
                          });
                        }}
                      ></Dropdown>
                    </div>
                    <div className="data-field">
                      <span className="label">Código postal</span>
                      <InputData
                        tabIndex={17}
                        maxLength={10}
                        type="type-alphanum-ext"
                        size={3}
                        input={currentSupplier.cp}
                        onChange={(e) => {
                          setCurrentSupplier({
                            ...currentSupplier,
                            cp: e,
                          });
                        }}
                      ></InputData>
                    </div>
                    <div className="data-field">
                      <span className="label">Email 1</span>
                      <InputData
                        tabIndex={18}
                        maxLength={50}
                        type="type-email"
                        size={3}
                        input={currentSupplier.email1}
                        onChange={(e) => {
                          setCurrentSupplier({
                            ...currentSupplier,
                            email1: e,
                          });
                        }}
                        icon="/images/link.svg"
                        onClick={() => {
                          openEmail(currentSupplier.email1);
                        }}
                      ></InputData>
                    </div>
                    <div className="data-field">
                      <span className="label">Email 2</span>
                      <InputData
                        tabIndex={19}
                        maxLength={50}
                        type="type-email"
                        size={3}
                        input={currentSupplier.email2}
                        onChange={(e) => {
                          setCurrentSupplier({
                            ...currentSupplier,
                            email2: e,
                          });
                        }}
                        icon="/images/link.svg"
                        onClick={() => {
                          openEmail(currentSupplier.email2);
                        }}
                      ></InputData>
                    </div>
                  </div>
                  <div className="supplier-info-container-col">
                    <div className="data-field">
                      <span className="label">Teléfono 1</span>
                      <InputData
                        tabIndex={20}
                        maxLength={20}
                        type="type-phone"
                        size={3}
                        input={currentSupplier.telefono1}
                        onChange={(e) => {
                          setCurrentSupplier({
                            ...currentSupplier,
                            telefono1: e,
                          });
                        }}
                      ></InputData>
                    </div>
                    <div className="data-field">
                      <span className="label">Teléfono 2</span>
                      <InputData
                        tabIndex={21}
                        maxLength={20}
                        type="type-phone"
                        size={3}
                        input={currentSupplier.telefono2}
                        onChange={(e) => {
                          setCurrentSupplier({
                            ...currentSupplier,
                            telefono2: e,
                          });
                        }}
                      ></InputData>
                    </div>
                    <div className="data-field">
                      <span className="label">Móvil 1</span>
                      <InputData
                        tabIndex={22}
                        maxLength={20}
                        type="type-phone"
                        size={3}
                        input={currentSupplier.movil1}
                        onChange={(e) => {
                          setCurrentSupplier({
                            ...currentSupplier,
                            movil1: e,
                          });
                        }}
                      ></InputData>
                    </div>
                    <div className="data-field">
                      <span className="label">Móvil 2</span>
                      <InputData
                        tabIndex={23}
                        maxLength={20}
                        type="type-phone"
                        size={3}
                        input={currentSupplier.movil2}
                        onChange={(e) => {
                          setCurrentSupplier({
                            ...currentSupplier,
                            movil2: e,
                          });
                        }}
                      ></InputData>
                    </div>
                    <div className="data-field">
                      <span className="label">Whatsapp</span>
                      <InputData
                        tabIndex={24}
                        maxLength={20}
                        type="type-phone"
                        size={3}
                        input={currentSupplier.whatsapp}
                        onChange={(e) => {
                          setCurrentSupplier({
                            ...currentSupplier,
                            whatsapp: e,
                          });
                        }}
                        icon="/images/link.svg"
                        onClick={() => {
                          if (currentSupplier.whatsapp !== "") {
                            openWhatsapp(currentSupplier.whatsapp);
                          }
                        }}
                      ></InputData>
                    </div>
                    <div className="data-field">
                      <span className="label">Web</span>
                      <InputData
                        tabIndex={25}
                        maxLength={50}
                        type="text"
                        size={3}
                        input={currentSupplier.web}
                        onChange={(e) => {
                          setCurrentSupplier({
                            ...currentSupplier,
                            web: e,
                          });
                        }}
                      ></InputData>
                    </div>
                    <div className="data-field">
                      <span className="label">Código de proveedor</span>
                      <InputData
                        tabIndex={26}
                        maxLength={20}
                        type="type-alphanum-ext"
                        size={3}
                        input={currentSupplier.codigoCliente}
                        bkg={true}
                        onChange={(e) => {
                          setCurrentSupplier({
                            ...currentSupplier,
                            codigoCliente: e,
                          });
                        }}
                      ></InputData>
                    </div>
                    <div className="data-field">
                      <span className="label">Código de envío</span>
                      <InputData
                        tabIndex={27}
                        maxLength={20}
                        type="type-alphanum-ext"
                        size={3}
                        input={currentSupplier.codigoEnvio}
                        onChange={(e) => {
                          setCurrentSupplier({
                            ...currentSupplier,
                            codigoEnvio: e,
                          });
                        }}
                      ></InputData>
                    </div>
                    <div className="data-field">
                      <span className="label">Código de facturación</span>
                      <InputData
                        tabIndex={28}
                        maxLength={20}
                        type="type-alphanum-ext"
                        size={3}
                        input={currentSupplier.codigoFacturacion}
                        onChange={(e) => {
                          setCurrentSupplier({
                            ...currentSupplier,
                            codigoFacturacion: e,
                          });
                        }}
                      ></InputData>
                    </div>
                  </div>
                </div>
                <div className="data-field">
                  <span
                    className="label"
                    style={{ textAlign: "start", width: 98 }}
                  >
                    Notas
                  </span>
                  <InputTextArea
                    tabIndex={29}
                    type="type-full"
                    size={0}
                    input={currentSupplier.notas}
                    onChange={(e) => {
                      setCurrentSupplier({
                        ...currentSupplier,
                        notas: e,
                      });
                    }}
                    extra="small-height"
                  ></InputTextArea>
                </div>
              </div>
              <div
                className="supplier-info-container-col"
                style={{ width: "200px" }}
              >
                <div className="opt-table-title">Familias de producto</div>
                <div
                  className="data-field c-pointer"
                  style={{ height: "28px" }}
                  onClick={() => {
                    setCurrentSupplier({
                      ...currentSupplier,
                      audifonos: !currentSupplier.audifonos,
                    });
                  }}
                >
                  <span className="label">Audífonos</span>
                  <CheckBox
                    tabIndex={30}
                    active={currentSupplier.audifonos}
                    onClick={() => {}}
                  ></CheckBox>
                </div>
                <div
                  className="data-field c-pointer"
                  style={{ height: "28px" }}
                  onClick={() => {
                    setCurrentSupplier({
                      ...currentSupplier,
                      cristales: !currentSupplier.cristales,
                    });
                  }}
                >
                  <span className="label">Lentes oftálmicas</span>
                  <CheckBox
                    tabIndex={31}
                    active={currentSupplier.cristales}
                    onClick={() => {}}
                  ></CheckBox>
                </div>
                <div
                  className="data-field c-pointer"
                  style={{ height: "28px" }}
                  onClick={() => {
                    setCurrentSupplier({
                      ...currentSupplier,
                      lentillas: !currentSupplier.lentillas,
                    });
                  }}
                >
                  <span className="label">Lentes de contacto</span>
                  <CheckBox
                    tabIndex={32}
                    active={currentSupplier.lentillas}
                    onClick={() => {}}
                  ></CheckBox>
                </div>
                <div
                  className="data-field c-pointer"
                  style={{ height: "28px" }}
                  onClick={() => {
                    setCurrentSupplier({
                      ...currentSupplier,
                      liquidos: !currentSupplier.liquidos,
                    });
                  }}
                >
                  <span className="label">Líquido</span>
                  <CheckBox
                    tabIndex={33}
                    active={currentSupplier.liquidos}
                    onClick={() => {}}
                  ></CheckBox>
                </div>
                <div
                  className="data-field c-pointer"
                  style={{ height: "28px" }}
                  onClick={() => {
                    setCurrentSupplier({
                      ...currentSupplier,
                      monturas: !currentSupplier.monturas,
                    });
                  }}
                >
                  <span className="label">Monturas</span>
                  <CheckBox
                    tabIndex={34}
                    active={currentSupplier.monturas}
                    onClick={() => {}}
                  ></CheckBox>
                </div>
                <div
                  className="data-field c-pointer"
                  style={{ height: "28px" }}
                  onClick={() => {
                    setCurrentSupplier({
                      ...currentSupplier,
                      varios: !currentSupplier.varios,
                    });
                  }}
                >
                  <span className="label">Varios</span>
                  <CheckBox
                    tabIndex={35}
                    active={currentSupplier.varios}
                    onClick={() => {}}
                  ></CheckBox>
                </div>
                <div
                  className="data-field c-pointer"
                  style={{ height: "28px" }}
                  onClick={() => {
                    setCurrentSupplier({
                      ...currentSupplier,
                      gafas: !currentSupplier.gafas,
                    });
                  }}
                >
                  <span className="label">Gafas de sol</span>
                  <CheckBox
                    tabIndex={36}
                    active={currentSupplier.gafas}
                    onClick={() => {}}
                  ></CheckBox>
                </div>
              </div>
              <div className="supplier-info-container-col">
                <div className="opt-table-title">% DTO</div>
                <div className="data-field">
                  <InputData
                    tabIndex={37}
                    type="type-float2"
                    size={5}
                    input={currentSupplier.descuentoAudifonos}
                    onChange={(e) => {
                      setCurrentSupplier({
                        ...currentSupplier,
                        descuentoAudifonos: e,
                      });
                    }}
                  ></InputData>
                </div>
                <div className="data-field">
                  <InputData
                    tabIndex={38}
                    type="type-float2"
                    size={5}
                    input={currentSupplier.descuentoCristales}
                    onChange={(e) => {
                      setCurrentSupplier({
                        ...currentSupplier,
                        descuentoCristales: e,
                      });
                    }}
                  ></InputData>
                </div>
                <div className="data-field">
                  <InputData
                    tabIndex={39}
                    type="type-float2"
                    size={5}
                    input={currentSupplier.descuentoLentillas}
                    onChange={(e) => {
                      setCurrentSupplier({
                        ...currentSupplier,
                        descuentoLentillas: e,
                      });
                    }}
                  ></InputData>
                </div>
                <div className="data-field">
                  <InputData
                    tabIndex={40}
                    type="type-float2"
                    size={5}
                    input={currentSupplier.descuentoLiquidos}
                    onChange={(e) => {
                      setCurrentSupplier({
                        ...currentSupplier,
                        descuentoLiquidos: e,
                      });
                    }}
                  ></InputData>
                </div>
                <div className="data-field">
                  <InputData
                    tabIndex={41}
                    type="type-float2"
                    size={5}
                    input={currentSupplier.descuentoMonturas}
                    onChange={(e) => {
                      setCurrentSupplier({
                        ...currentSupplier,
                        descuentoMonturas: e,
                      });
                    }}
                  ></InputData>
                </div>
                <div className="data-field">
                  <InputData
                    tabIndex={42}
                    type="type-float2"
                    size={5}
                    input={currentSupplier.descuentoVarios}
                    onChange={(e) => {
                      setCurrentSupplier({
                        ...currentSupplier,
                        descuentoVarios: e,
                      });
                    }}
                  ></InputData>
                </div>
                <div className="data-field">
                  <InputData
                    tabIndex={43}
                    type="type-float2"
                    size={5}
                    input={currentSupplier.descuentoGafas}
                    onChange={(e) => {
                      setCurrentSupplier({
                        ...currentSupplier,
                        descuentoGafas: e,
                      });
                    }}
                  ></InputData>
                </div>
              </div>
            </div>
            <div className="supplier-container-options">
              <ButtonIconH
                text="Guardar"
                onClick={async () => {
                  await saveSupplier();
                }}
              ></ButtonIconH>
              {currentSupplier.id !== -1 && (
                <ButtonIconH
                  text="Eliminar"
                  disabled={!currentSupplier.modificable}
                  onClick={async () => {
                    props.createPopupQuestion(
                      `¿Desea eliminar el proveedor?`,
                      async () => {
                        await deleteSupplier();
                        props.removePopupQuestion();
                        props.onClose();
                      },
                      props.removePopupQuestion,
                    );
                  }}
                ></ButtonIconH>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
